import { Navigate } from 'react-router-dom';
import { useAuth }  from './AuthContext';
import EmojiLoader  from './EmojiLoader';

export default function RequireOnboarded({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <EmojiLoader />;

  // Não logado
  if (!user) return <Navigate to="/login" replace />;

  // Admin não precisa de onboarding
  if (user.role === 'admin') return children;

  // Garante número e fallback
  const stage = Number.isFinite(Number(user.onboardStage))
    ? Number(user.onboardStage)
    : 0;

  // Se não finalizou onboarding (stage < 4), manda pra onboarding
  if (stage < 4) return <Navigate to="/onboarding" replace />;

  return children;
}